import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {

  const toastService = inject(ToastService);

  
  return next(req).pipe(
    catchError( (error: HttpErrorResponse) => {

      let errorMessage = 'An error occurred. Please try again.';
      let toastType: 'success' | 'danger' | 'info' = 'danger';
      let header = 'Error';


     if (error.status === 401) {
        errorMessage = 'You are not authenticated. Please log in.';
        header = 'Authentication Error';
      } else if (error.status === 403) {
        errorMessage = 'You do not have permission to perform this action.';
        header = 'Permission Denied';
      } else if (error.status === 0) {
        errorMessage = 'Unable to connect to the server. Please check your network or try again later.';
        header = 'Connection Error';
        toastType = 'info';
      }

      toastService.show(header, errorMessage, toastType, 5000);

      return throwError(() => error);
    })
  );
};
